import { atom } from "recoil";

import { RidesCalendarRowsFilter } from "./rides-calendar.models";

export const ridesCalendarRowsFilterAtom = atom<RidesCalendarRowsFilter>({
  key: "ridesCalendarRowsFilterAtom",
  default: "all",
});
